import React from 'react';
import { nullFn } from '../utils';
import CrossIcon from '../../../../assets/images/svg/CrossIcon';
import { DatePickerInputCalendar } from './DatePickerInputCalendar';
import { DatePickerInputModalProps } from '../types';

export function DatePickerInputModal({
  id = undefined,
  className = undefined,
  style = undefined,
  value = undefined,
  locale = 'en-US',
  maxValue = undefined,
  minValue = undefined,
  isOpen = false,
  onChange = nullFn,
  onClose = nullFn,
  selectionType = 'single',
  variant,
}: DatePickerInputModalProps): JSX.Element | null {
  const calendarId = id && `${id}_calendar`;

  return isOpen ? (
    <div
      id={id}
      className={`fixed top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center z-50 m-auto bg-gray-darkest bg-opacity-50 h-screen;
      ${className !== undefined ? className : ''}`}
      style={style}
    >
      <div className='top-0 right-0 left-0 bottom-0 w-1/2 min-w-modal max-h-modal min-h-modal bg-white rounded-lg shadow-lg flex flex-col justify-center relative'>
        <button
          className='absolute top-2 right-2 z-10'
          type='button'
          onClick={onClose}
        >
          <span>
            <CrossIcon width='15' height='15' strokeWidth='1' />
          </span>
        </button>
        <div className='p-4 overflow-hidden overflow-y-auto box-border'>
          <DatePickerInputCalendar
            id={calendarId}
            value={value}
            minValue={minValue}
            maxValue={maxValue}
            locale={locale}
            onChange={onChange}
            selectionType={selectionType}
            variant={variant}
          />
        </div>
      </div>
    </div>
  ) : null;
}
